const INITIAL_STATE = {
  items: [],
  fetchingInProgressSince: null,
  lastSuccessfulFetch: null,
  lastFailedFetch: null,
  lastErrorMessage: null,
};

module.exports = function DailyQuestsReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case 'SET_LANGUAGE':
      return {
        ...state,
        didInvalidate: true,
      };
    case 'FETCH_DAILY_QUESTS_IN_PROGRESS':
      return {
        ...state,
        fetchingInProgressSince: action.timestamp,
        fetchPromise: action.fetchPromise,
      };
    case 'FETCH_DAILY_QUESTS_SUCCESSFUL':
      return {
        ...state,
        fetchingInProgressSince: null,
        items: action.quests,
        lastSuccessfulFetch: action.timestamp,
        fetchPromise: null,
      };
    case 'FETCH_DAILY_QUESTS_FAILED':
      return {
        ...state,
        fetchingInProgressSince: null,
        lastFailedFetch: action.timestamp,
        lastErrorMessage: action.reason,
        fetchPromise: null,
      };
    default:
      return state;
  }
};
